import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Button, Card, Col, Form, Input,
} from 'antd';
import { Link } from 'react-router-dom';
import { validation_rules } from '../../../../shared/validation_rules';
import { createAffiliateRequest } from '../redux/actions/create_affiliate.actions';

const FormItem = Form.Item;

export default connect()(class AffiliateCreate extends Component {
  state = {
      name: '',
      abbr: '',
      old_crm_affiliate_id: '',
      loans_affiliate_id: '',
      description: '',
  };

  getInputValueHandler = event => this.setState({ [event.target.name]: event.target.value });

  handleSubmit = () => this.props.dispatch(createAffiliateRequest(this.state));

  render() {
      const isDisabled = Object.keys(this.state).some(field => !this.state[field].length && field !== 'old_crm_affiliate_id');
      const { isValueExist } = validation_rules;
      return (
          <Col span={24}>
              <Card className="border-shadows">
                  <Form>
                      <FormItem style={{ marginTop: 10 }} label="Name">
                          <Input
                              maxLength={20}
                              autoComplete="off"
                              name="name"
                              style={{ marginTop: 10 }}
                              placeholder="Enter affiliate name"
                              onChange={this.getInputValueHandler}
                          />
                          <span className="createUserValidationError">
                              {isValueExist(this.state.name)}
                          </span>
                      </FormItem>
                      <FormItem style={{ marginTop: 20 }} label="Abbreviation">
                          <Input
                              maxLength={5}
                              autoComplete="off"
                              name="abbr"
                              style={{ marginTop: 10 }}
                              placeholder="Enter affiliate abbreviation"
                              onChange={this.getInputValueHandler}
                          />
                          <span className="createUserValidationError">
                              {isValueExist(this.state.abbr)}
                          </span>
                      </FormItem>
                      <FormItem style={{ marginTop: 20 }} label="Old Crm Affiliate ID">
                          <Input
                              type="number"
                              name="old_crm_affiliate_id"
                              style={{ marginTop: 10 }}
                              placeholder="Enter old CRM affiliate ID"
                              onChange={this.getInputValueHandler}
                          />
                      </FormItem>
                      <FormItem style={{ marginTop: 20 }} label="Loans Affiliate ID">
                          <Input
                              type="number"
                              name="loans_affiliate_id"
                              style={{ marginTop: 10 }}
                              placeholder="Enter Loans affiliate ID"
                              onChange={this.getInputValueHandler}
                          />
                      </FormItem>
                      <FormItem style={{ marginTop: 20 }} label="Description">
                          <Input.TextArea
                              maxLength={200}
                              name="description"
                              style={{ marginTop: 10 }}
                              placeholder="Description"
                              onChange={this.getInputValueHandler}
                          />
                          <span className="createUserValidationError">
                              {isValueExist(this.state.description)}
                          </span>
                      </FormItem>
                      <div style={{ float: 'right', marginTop: 20 }}>
                          <Link to="/PlatformManagement/Manage_affiliates">
                              <Button>Back to List</Button>
                          </Link>
                          <Button
                              type="primary"
                              disabled={isDisabled}
                              style={{ marginLeft: 10 }}
                              onClick={this.handleSubmit}
                          >
                              Add Affiliate
                          </Button>
                      </div>
                  </Form>
              </Card>
          </Col>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_create/components/AffiliateCreate.js